import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { SZMA102AService, Szma102aResponseCtrSearchResultDto, Szma102aResponse, Szma102aRequest } from 'sg-api';
import { map, timeout, catchError } from 'rxjs/operators';
import { ApiCommonService } from 'cbc-shared-lib';
import { TimeApiService } from 'cbc-shared-lib';
import { FEATURES_LIB_CONFIG } from '../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../config/features-lib-config';
import { SgkbConstains } from '../sg-kb-constans';

@Injectable({
  providedIn: 'root'
})
export class UsedSzma102aService {
  /** お客さま情報検索結果のSubject */
  private _contractorResult$: Subject<Szma102aResponse> = new Subject<Szma102aResponse>();

  /**
   * お客さま情報検索結果のobservable提供
   *
   * @readonly
   * @memberof UsedSzma102aService
   */
  get contractorValueChanges(): Observable<Szma102aResponse> {
    return this._contractorResult$.asObservable();
  }

  /**
   * コンストラクタ
   * @param {SZZA005AService} sZZA005AService
   * @memberof InitialInfoService
   */
  constructor(private sZMA102AService: SZMA102AService, private apiCommonService: ApiCommonService, private timeApiService: TimeApiService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * お客さま情報検索API呼び出し
   *
   * @param {*} value
   * @memberof UsedSzma102aService
   */
  searchContractor(value: any, noCheckError = false): Observable<Szma102aResponse> {
    // 空の契約お客さま番号リストのArrayを再設定する
    this.resetEmptyArray(value);

    return this.sZMA102AService.c13RSZMA102APost(<Szma102aRequest>this.apiCommonService.setRequestCommon(value), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          if (noCheckError) {
            this.apiCommonService.checkErrorNoSearchData(response);
          } else {
            this.apiCommonService.checkError(response);
          }

          if (response.body.ctrSearchResultList != null) {
            this._contractorResult$.next(this.setResponseInitialData(response.body));
          } else {
            response.body.ctrSearchResultList = [];
            this._contractorResult$.next(response.body);
          }
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, SgkbConstains.MESSAGE.ID_FF,
            SgkbConstains.MESSAGE.APINAME_SZMA102A);
          return throwError(err.message);
        }));
  }

  /**
   * 空のArray要素の変換処理
   * [""] -> []
   *
   * @param {*} request
   * @memberof UsedSzoa102aService
   */
  resetEmptyArray(request: any): void {
    // 契約お客さま番号リスト
    if (request?.ctrSearchInfo?.firstSrvctrNoList != null) {
      if (request.ctrSearchInfo.firstSrvctrNoList[0] == '') {
        // [""]のArray要素を[]に変換
        request.ctrSearchInfo.firstSrvctrNoList = [];
      }
    }
    // 外部接続番号リスト
    if (request?.ctrSearchInfo?.extCnnctNoList != null) {
      if (request.ctrSearchInfo.extCnnctNoList[0] == '') {
        // [""]のArray要素を[]に変換
        request.ctrSearchInfo.extCnnctNoList = [];
      }
    }
    // プロダクトコードリスト
    if (request?.ctrSearchInfo?.prdCodeList != null) {
      if (request.ctrSearchInfo.prdCodeList[0] == '') {
        // [""]のArray要素を[]に変換
        request.ctrSearchInfo.prdCodeList = [];
      }
    }
    // 請求確定番号リスト
    if (request?.ctrSearchInfo?.claimFixNoList != null) {
      if (request.ctrSearchInfo.claimFixNoList[0] == '') {
        // [""]のArray要素を[]に変換
        request.ctrSearchInfo.claimFixNoList = [];
      }
    }
    // 使用お客さま番号リスト
    if (request?.ctrSearchInfo?.logicDeviceNoList != null) {
      if (request.ctrSearchInfo.logicDeviceNoList[0] == '') {
        // [""]のArray要素を[]に変換
        request.ctrSearchInfo.logicDeviceNoList = [];
      }
    }
  }

  /**
   * レスポンスに対し、Array<Szma102aResponseCtrSearchResultDto>の初期表示値を作成
   *
   * @return {*}  {Szma102aResponse}
   * @memberof UsedSzma102aService
   */
  setResponseInitialData(response: Szma102aResponse): Szma102aResponse {

    response.ctrSearchResultList.forEach((ctrSearchResultList) => {

      if (!ctrSearchResultList.ctrCommonMstInfo || (Object.keys(ctrSearchResultList.ctrCommonMstInfo).length == 0)) {
        ctrSearchResultList.ctrCommonMstInfo = {
          objectGroup: "",
          objectGroupAname: "",
          ctrNo: "",
          updateSrno: "",
          srvCtrNo: "",
          prdCode: "",
          prdCtrDate: "",
          prdBreakDate: "",
          firstSrvctrNo: "",
          ctrStateDiv: "",
          ctrStateDivAname: "",
          salfrmCode: "",
          salfrmCodeAname: "",
          rlyisdVisitNo: "",
          rlystrFname: "",
          portalId: "",
          certCode: "",
          payTmprryPw: "",
          agnissVisitNo: "",
          claimMnttmDiv: "",
          claimMnttmDivAname: "",
          ctrefctkiStrtdate: "",
          srvctrInfoMemo: "",
          ctrSyuseiDate: "",
          srvctrBreakRsncod: "",
          srvctrBreakRsncodAname: "",
          autksnCtrfrmDiv: "",
          autksnCtrfrmDivAname: "",
          regTrnDate: "",
          ctrcanTrnDate: "",
          ctrEfctedDate: "",
          claimUnit: "",
          claimUnitAname: "",
          rcvmnySiteiMonth: "",
          rcvmnySiteiMonthAname: "",
          ctrnumBrcno: "",
          ctrupdDiv: "",
          ctrupdDivAname: "",
          ctrStrtdt: "",
          ctrEnddt: "",
          prdAname: "",
          prdRyaku: "",
          prdDispAname: "",
          businsCode: "",
          businsCodeAname: "",
          prdClsfyDiv: "",
          prdClsfyDivAname: "",
          srvClsfyCode: "",
          srvClsfyCodeAname: ""
        }
      }
      if (!ctrSearchResultList.ctrperMstInfo || (Object.keys(ctrSearchResultList.ctrperMstInfo).length == 0)) {
        ctrSearchResultList.ctrperMstInfo = {
          visitNo: "",
          visitKanaName: "",
          visitName: "",
          visitDiv: "",
          visitDivAname: "",
          telNoDiv1: "",
          telNoDiv1Aname: "",
          telNo1: "",
          telNoDiv2: "",
          telNoDiv2Aname: "",
          telNo2: "",
          telNoDiv3: "",
          telNoDiv3Aname: "",
          telNo3: "",
          maddr1: "",
          faxNo1: "",
          addrcd: "",
          postno: "",
          pfcAname: "",
          pfcKanaAname: "",
          mptAname: "",
          mptKanaAname: "",
          twareaAname: "",
          twareaKanaAname: "",
          oazaAname: "",
          oazaKanaAname: "",
          banti: "",
          gou: "",
          bunptGou: "",
          supadrAname: "",
          supadrKananm: "",
          yagouAname: "",
          yagouKananm: ""
        }
      }
      if (!ctrSearchResultList.empposUserMstInfo || (Object.keys(ctrSearchResultList.empposUserMstInfo).length == 0 || !ctrSearchResultList.empposUserMstInfo.empposUserMstList)) {
        ctrSearchResultList.empposUserMstInfo = {
          empposUserMstList: [{
            empposMstInfo: {
              logicDeviceNo: "",
              srvClsfyCode: "",
              srvClsfyCodeAname: "",
              extCnnctNo: "",
              addrcd: "",
              postno: "",
              pfcAname: "",
              pfcKanaAname: "",
              mptAname: "",
              mptKanaAname: "",
              twareaAname: "",
              twareaKanaAname: "",
              oazaAname: "",
              oazaKanaAname: "",
              banti: "",
              gou: "",
              bunptGou: "",
              supadrAname: "",
              supadrKananm: "",
              yagouAname: "",
              yagouKananm: ""
            },
            userMstInfo: {
              visitNo: "",
              visitKanaName: "",
              visitName: "",
              visitDiv: "",
              visitDivAname: "",
              telNoDiv1: "",
              telNoDiv1Aname: "",
              telNo1: "",
              telNoDiv2: "",
              telNoDiv2Aname: "",
              telNo2: "",
              telNoDiv3: "",
              telNoDiv3Aname: "",
              telNo3: "",
              maddr1: "",
              faxNo1: "",
              addrcd: "",
              postno: "",
              pfcAname: "",
              pfcKanaAname: "",
              mptAname: "",
              mptKanaAname: "",
              twareaAname: "",
              twareaKanaAname: "",
              oazaAname: "",
              oazaKanaAname: "",
              banti: "",
              gou: "",
              bunptGou: "",
              supadrAname: "",
              supadrKananm: "",
              yagouAname: "",
              yagouKananm: ""
            }
          }]
        };
      }

      ctrSearchResultList.empposUserMstInfo.empposUserMstList.forEach((empposUserMstList) => {

        if (!empposUserMstList.empposMstInfo || (Object.keys(empposUserMstList.empposMstInfo).length == 0)) {
          empposUserMstList.empposMstInfo = {
            logicDeviceNo: "",
            srvClsfyCode: "",
            srvClsfyCodeAname: "",
            extCnnctNo: "",
            addrcd: "",
            postno: "",
            pfcAname: "",
            pfcKanaAname: "",
            mptAname: "",
            mptKanaAname: "",
            twareaAname: "",
            twareaKanaAname: "",
            oazaAname: "",
            oazaKanaAname: "",
            banti: "",
            gou: "",
            bunptGou: "",
            supadrAname: "",
            supadrKananm: "",
            yagouAname: "",
            yagouKananm: ""
          }
        }

        if (!empposUserMstList.userMstInfo || (Object.keys(empposUserMstList.userMstInfo).length == 0)) {
          empposUserMstList.userMstInfo = {
            visitNo: "",
            visitKanaName: "",
            visitName: "",
            visitDiv: "",
            visitDivAname: "",
            telNoDiv1: "",
            telNoDiv1Aname: "",
            telNo1: "",
            telNoDiv2: "",
            telNoDiv2Aname: "",
            telNo2: "",
            telNoDiv3: "",
            telNoDiv3Aname: "",
            telNo3: "",
            maddr1: "",
            faxNo1: "",
            addrcd: "",
            postno: "",
            pfcAname: "",
            pfcKanaAname: "",
            mptAname: "",
            mptKanaAname: "",
            twareaAname: "",
            twareaKanaAname: "",
            oazaAname: "",
            oazaKanaAname: "",
            banti: "",
            gou: "",
            bunptGou: "",
            supadrAname: "",
            supadrKananm: "",
            yagouAname: "",
            yagouKananm: ""
          }
        }
      });
    });
    return response;
  }
}

